import React from 'react';
import EmbedPage from 'src/shared/components/EmbedPage/EmbedPage';
import { OPTIONS } from './constants/embedApiOptions';

export default function EmbedApi({ productSelected }) {
  return <EmbedPage options={OPTIONS} productSelected={productSelected}></EmbedPage>;
}
